/* eslint-disable eqeqeq */
/* eslint-disable no-useless-computed-key */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */

import { Avatar, Collapse, Image, Rate, Select, Tooltip } from "antd";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setTemplateDetails,
  setTemplateSectionBrands,
  setTemplateWidgetBrands,
} from "../../../../redux/actions/section/section";
import { setTemplateFilter } from "../../../../redux/actions/section/section";
import { setTicketOffset } from "../../../../redux/actions/ormWidget/Orm";
import { setTicketLoader } from "../../../../redux/actions/ormWidget/OrmWidget";
import {
  setBrandActiveKey,
  setSelectBrandValue,
  setGlobalBrandValue,
  updateDashboardBrands,
  setDashboardBrandObj,
  setSelectProfileId,
  setChannelImage,
  setProfileImage,
} from "../../../../redux/actions/Template";
import { getPaneIndex, getUniqueFilters } from "../../../../redux/constants";
import { setGraphBrands } from "../../../../redux/actions/dashboard/Welcome";
import { setOrmBrands } from "../../../../redux/actions/ormWidget/Orm";
import { setWidgetLoader } from "../../../../redux/actions/ApiCall/apiCall";
import { setGlobalSingleBrands } from "../../../../redux/actions/AuthParams";
import {
  setCampaignDate,
  setClearGraphData,
  setGlobalFilter,
  setPaneDuration,
  setProfileInfoPane,
  setTemplateInPane,
} from "../../../../redux/actions/dashboard/Tab1";
import defaultImage from "../../../../assets/brandLogos/Default_Brand.svg";
import location from "../../../../assets/location.svg";
import accoArrow from "../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import Text from "antd/lib/typography/Text";
import moment from "moment";
import isEqual from "react-fast-compare";
import { setScheduleQuickFilter } from "../../../../redux/actions/scheduleReport/scheduleReport";
import { SocialMedialogo } from "../../DeepDive/DeepDivetab/SocialMediaPlatforms";
import { setCampaignQuickProfile } from "../../../../redux/actions/commandCenter/screens/screen";
import MultipleQuickFiltersSelectDropdown from "./MultipleQuickFiltersSelectDropdown";
import { FixedSizeList } from "react-window";
import { getCampaignStatusIcons } from "../../../../redux/constants/CampaignStatusIcons";

const { Option } = Select;
const ProfileSelection = ({
  type,
  AccountType,
  IsAdsSetType = false,
  IsAdsType = false,
  isSwitchingAllowed = false,
}) => {
  const dispatch = useDispatch();
  const [profileDrop, setProfileDrop] = useState("");
  const [selectedProfileValue, setSelectedProfileValue] = useState(null);
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const screen = useSelector((state) => state?.Screens?.screen);
  const screenCampaignProfileList = useSelector(
    (state) => state?.Screens?.campaign_profile_list
  );
  const isCampaignPopupOpen = useSelector(
    (state) => state?.Screens?.open_campaign_popup
  );
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const templateData = useSelector((state) => state.Template);
  const profileId = useSelector((state) => state.Template.profileId);
  const channelImage = useSelector((state) => state.Template.channelImage);
  const profileImage = useSelector((state) => state.Template.profileImage);
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const index = getPaneIndex(panes, activeKey);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const multileProfileSelectionInShare = useSelector(
    (state) => state?.ApiCall?.multileProfileSelection
  );
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const personalisationSettingsInPersonalisationState = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const scheduleObj = useSelector((state) => state.scheduleReport.scheduleObj);
  const profileLoader = useSelector((state) => state.apiCall.profileLoader);
  const [open, setOpen] = useState();
  const controlNavbar = () => {
    if (window.scrollY > 0) {
      setOpen(false);
    }
  };
  const accountType = ["AccountID", "SettingID", "Ads_Campaign", "ProfileID"];
  const accountTypeWithLowerCase = [
    "accountid",
    "settingid",
    "ads_campaign",
    "profileid",
  ];
  const dontShowProfileUIFor = ["Ads_Campaign", "ProfileID"];
  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, []);

  const handleOnSelectChange = (e) => {
    setSelectedProfileValue(e);
    if (type === "CommandCenterCampaign") {
      let duration1 = {
        from: e?.split("valuesplit")?.[4],
        to: e?.split("valuesplit")?.[5]
          ? e?.split("valuesplit")?.[5]
          : moment(new Date()).format("YYYY/MM/DD h:mm"),
      };
      let profileFilters = {
        attribute:
          screen?.quick_filter === "AccountID"
            ? "SettingID"
            : screen?.quick_filter === "Category"
            ? "CategoryID"
            : screen?.quick_filter,
        type: "varchar",
        columns: [
          {
            name: e?.split("valuesplit")?.[1],
            type: "include",
            display_name: e?.split("valuesplit")?.[0],
          },
        ],
        name: e?.split("valuesplit")?.[0],
        channel: e?.split("valuesplit")?.[2],
        profile_icon_url: e?.split("valuesplit")?.[3],
        duration: duration1,
      };
      dispatch(setCampaignQuickProfile(profileFilters));
      dispatch(setSelectProfileId(e?.split("valuesplit")?.[0]));
      dispatch(setChannelImage(e?.split("valuesplit")?.[2]));
      dispatch(setProfileImage(e?.split("valuesplit")?.[3]));
    } else {
      let index = getPaneIndex(panes, activeKey);
      let profileFilters = {
        attribute:
          panes[index]?.quick_filter === "AccountID"
            ? "SettingID"
            : panes[index]?.quick_filter === "Category"
            ? "CategoryID"
            : panes[index]?.quick_filter,
        data_source: panes[index]?.quick_filter_source
          ? panes[index]?.quick_filter_source
          : "mentions",
        type: "varchar",
        columns: [
          {
            name: e?.split("valuesplit")?.[1],
            type: "include",
            display_name: e?.split("valuesplit")?.[0],
          },
        ],
      };
      //let hidden_filter = panes[index]?.hidden_filter;

      // let filters = panes[index].filters
      //   ? panes[index].filters?.filter(
      //       (el) =>
      //         el?.attribute !== "Category" &&
      //         !graphConditionConfig?.[`quick-filter-keys`]?.includes(
      //           el?.attribute
      //         )
      //     )
      //   : [];

      // let finalFilter = [...filters, ...profileFilters];

      // let uniqueFilters = getUniqueFilters(finalFilter);
      // panes[index].filters = uniqueFilters;
      // panes[index].predefined &&
      //   uniqueFilters?.length === 0 &&
      //   panes[index]?.template_type === "ticket" &&
      //   panes[index].template_id === "000-000-002" &&
      //   panes[index].template_id === "000-000-003" &&
      //   uniqueFilters.push(...panes[index].defaultFilters);

      let start_date =
        e?.split("valuesplit")?.[4] && moment(e?.split("valuesplit")?.[4]);
      let end_date =
        e?.split("valuesplit")?.[5] && moment(e?.split("valuesplit")?.[5]);
      let dateDiff;
      if (start_date && end_date) {
        dateDiff = end_date.diff(start_date, "days") + 1;
      }

      let duration1 = {
        from: e?.split("valuesplit")?.[4],
        to: e?.split("valuesplit")?.[5]
          ? e?.split("valuesplit")?.[5]
          : moment(new Date()).format("YYYY/MM/DD h:mm"),
      };

      if (panes[index]?.quick_filter === "CampaignID") {
        let endDate = moment(duration1?.to, "YYYY/MM/DD HH:mm");
        let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
        let endCurrentDiff = endDate.diff(currentDate, "days") + 1;

        if (endCurrentDiff > 0) {
          duration1.to = currentDate;
        }
      }

      panes[index]?.quick_filter === "CampaignID" &&
        dispatch(setCampaignDate(duration1, panes, index));

      let currentEndDate = moment(new Date()).format("YYYY/MM/DD H:mm");
      let final_end_date;
      if (
        e?.split("valuesplit")?.[4] < currentEndDate &&
        e?.split("valuesplit")?.[5] > currentEndDate
      ) {
        final_end_date = currentEndDate;
      }

      let final_date_diff;
      if (start_date && final_end_date) {
        final_date_diff = moment(final_end_date).diff(start_date, "days") + 1;
      }

      let final_start_date;
      if (final_date_diff < 7 && e?.split("valuesplit")?.[5] > currentEndDate) {
        final_start_date = moment(e?.split("valuesplit")?.[4]).format(
          "YYYY/MM/DD H:mm"
        );
      } else if (
        final_date_diff > 7 &&
        e?.split("valuesplit")?.[5] > currentEndDate
      ) {
        final_start_date = moment(final_end_date)
          .subtract(6, "d")
          .set({ hour: "00", minute: "00" })
          .format("YYYY/MM/DD HH:mm");
      } else if (dateDiff > 7 && e?.split("valuesplit")?.[5] < currentEndDate) {
        //check if diff is more than 7, then make the selected date 7 days, i.e end date -7
        final_start_date = moment(e?.split("valuesplit")?.[5])
          .subtract(6, "d")
          .set({ hour: "00", minute: "00" })
          .format("YYYY/MM/DD HH:mm");
      }

      let diffDuration = {
        from: final_start_date ? final_start_date : e?.split("valuesplit")?.[4],
        to: final_end_date ? final_end_date : e?.split("valuesplit")?.[5],
      };
      let paneObj1 = {
        panes: panes,
        index: index,
        duration:
          panes[index]?.quick_filter === "CampaignID" ? diffDuration : null,
      };

      let paneObj = {
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        authParams: authParams,
        index: index,
        competitorBrands: competitorBrands,
        duration:
          panes[index]?.quick_filter === "CampaignID" ? diffDuration : null,
        graphConditionConfig: graphConditionConfig,
        temporary_words: temporary_words,
      };

      let profileInfo = {
        name: e?.split("valuesplit")?.[0],
        channelType: e?.split("valuesplit")?.[2],
        profileIcon: e?.split("valuesplit")?.[3],
      };

      panes[index]?.quick_filter === "CampaignID" &&
        dispatch(setPaneDuration(paneObj1, "global_dashboard"));

      dispatch(setProfileInfoPane(profileInfo, index, panes, profileFilters));
      //dispatch(setTemplateDetails(templateDetails, { filters: uniqueFilters }));
      type !== "schedule_report" &&
        dispatch(
          setClearGraphData(index, panes, paneObj, {
            change_type: "global_profile",
          })
        );
      if (type === "schedule_report") {
        let scheduleQuickFilter = profileFilters;
        scheduleQuickFilter.name = profileInfo?.name;
        scheduleQuickFilter.profile_icon_url = profileInfo?.profileIcon;
        dispatch(setScheduleQuickFilter(scheduleQuickFilter, scheduleObj));
      }
      dispatch(setGlobalFilter(null, index, panes, paneObj));
      //dispatch(setOptionHighChart(null));
      dispatch(setSelectProfileId(e?.split("valuesplit")?.[0]));
      dispatch(setChannelImage(e?.split("valuesplit")?.[2]));
      dispatch(setProfileImage(e?.split("valuesplit")?.[3]));
    }
  };

  const handleOnSelectClick = (e) => {
    setProfileDrop(e?.type);
  };

  useEffect(() => {
    if (
      profileId ||
      accountType?.includes(AccountType) ||
      AccountType === "LocationID"
    ) {
      if (type === "CommandCenterCampaign") {
        if (
          screenCampaignProfileList &&
          screenCampaignProfileList?.length > 0
        ) {
          let profileIndex = screenCampaignProfileList?.findIndex((p) => {
            return p?.name === profileId;
          });
          let defaultProfileValue = getDefaultProfileValue(
            screenCampaignProfileList?.[profileIndex >= 0 ? profileIndex : 0]
          );
          setSelectedProfileValue(defaultProfileValue);
        } else if (
          screen?.profiles &&
          screen?.profiles?.length > 0 &&
          !isCampaignPopupOpen
        ) {
          let profileIndex = screen?.profiles?.findIndex((p) => {
            return p?.name === profileId;
          });
          let defaultProfileValue = getDefaultProfileValue(
            screen?.profiles?.[profileIndex >= 0 ? profileIndex : 0]
          );
          setSelectedProfileValue(defaultProfileValue);
        }
      } else {
        let index = getPaneIndex(panes, activeKey);
        if (
          (AccountType === "LocationID" ||
            accountType?.includes(AccountType)) &&
          type === "share-modal" &&
          !isSwitchingAllowed
        ) {
          const selectBrandValueQuickFilter = IsAdsType
            ? panes?.[index]?.ads_value
            : IsAdsSetType
            ? panes?.[index]?.adsset_value
            : panes?.[index]?.quick_filter_value;

          const selectedDefaultValue =
            selectBrandValueQuickFilter?.columns?.map((data) => {
              return data?.display_name;
            });
          setSelectedProfileValue(selectedDefaultValue);
        } else {
          if (
            panes?.[index]?.profiles &&
            panes?.[index]?.profiles?.length > 0
          ) {
            let profileIndex = panes?.[index]?.profiles?.findIndex((p) => {
              return p?.name === profileId;
            });
            let defaultProfileValue = getDefaultProfileValue(
              panes?.[index]?.profiles?.[profileIndex >= 0 ? profileIndex : 0]
            );
            setSelectedProfileValue(defaultProfileValue);
          }
        }
      }
    } else {
      setSelectedProfileValue(null);
    }
  }, [profileId]);
  const getDefaultProfileValue = (profile) => {
    return profile
      ? `${profile?.name}valuesplit${profile?.id}valuesplit${profile?.channel}valuesplit${profile?.profile_icon_url}valuesplit${profile?.start_date}valuesplit${profile?.end_date}valuesplit${profile?.StoreCode}valuesplit${profile?.StoreAddress}`
      : "Profile";
  };

  const getProfileList = () => {
    if (type === "CommandCenterCampaign") {
      return screenCampaignProfileList &&
        Array.isArray(screenCampaignProfileList) &&
        screenCampaignProfileList?.length > 0
        ? screenCampaignProfileList
        : [];
    } else if (
      IsAdsType &&
      panes?.[index]?.ads_list &&
      Array.isArray(panes[index]?.ads_list) &&
      panes[index]?.ads_list?.length
    ) {
      return panes[index]?.ads_list;
    } else if (
      IsAdsSetType &&
      panes?.[index]?.adsset_list &&
      Array.isArray(panes[index]?.adsset_list) &&
      panes[index]?.adsset_list?.length
    ) {
      return panes[index]?.adsset_list;
    } else if (
      panes?.[index]?.profiles &&
      Array.isArray(panes[index]?.profiles) &&
      panes[index]?.profiles?.length
    ) {
      return panes[index]?.profiles;
    }
    return [];
  };
  const updatedProfileList = useMemo(
    () => getProfileList(),
    [panes[index]?.profiles, screenCampaignProfileList]
  );

  const isAllSelectedLocation = (name) => {
    const selectedValue =
      Array.isArray(selectedProfileValue) === false
        ? selectedProfileValue?.split("valuesplit")?.[0]
        : "";

    return selectedValue === "All Locations" && selectedValue !== name
      ? true
      : false;
  };
  const getProfileListForShareTemplate = () => {
    return IsAdsType
      ? shareTemplateData?.ads_list
      : IsAdsSetType
      ? shareTemplateData?.adsset_list
      : shareTemplateData?.quick_filter_res;
  };
  const quickFilterResForShareTemplate = useMemo(
    () => getProfileListForShareTemplate(),
    [shareTemplateData?.quick_filter_res]
  );

  const renderOurRow = ({ index, style }) => {
    const locationData = quickFilterResForShareTemplate[index];
    const rowStyle = {
      ...style,
      borderBottom: !accountType?.includes(AccountType)
        ? "0.1rem solid #c7c7c7"
        : "",
      paddingTop: "0.2rem",
    };
    return (
      <div key={index} style={rowStyle}>
        <div
          className={`d-flex ${
            accountType?.includes(AccountType) ? "align-items-center" : ""
          }`}
        >
          {!accountType?.includes(AccountType) ? (
            <Image
              style={{
                width: "1.4rem",
                height: "1.6rem",
              }}
              className="mr-2"
              preview={false}
              src={location}
              fallback={location}
            />
          ) : (
            ""
          )}
          {!accountType?.includes(AccountType) ? (
            <p
              style={{
                width: "-webkit-fill-available",
                marginTop: "0.4rem",
              }}
            >
              <strong>{locationData?.name}</strong>
              <div>{locationData?.StoreAddress}</div>
              <div className="d-flex justify-content-between mt-1 white-space-nowrap">
                <div className="mr-2">
                  <Rate
                    disabled
                    value={locationData?.averageRating}
                    className="ratingList mr-1 mb-1"
                  />
                  <span className="font-weight600">
                    {locationData?.totalReviewCount}
                  </span>
                  <span className="font-weight600">
                    {"(" + locationData?.averageRating + ")"}
                  </span>
                </div>
                <div className="pr-1">
                  <strong className="mr-1">Store Code:</strong>
                  {locationData?.StoreCode && locationData?.StoreCode !== ""
                    ? ` ${locationData?.StoreCode}`
                    : ` NA`}
                </div>
              </div>
            </p>
          ) : (
            <p
              style={{
                width: "-webkit-fill-available",
                marginTop: "",
              }}
            >
              <div
                className="d-flex mt-1 ProfileSelection--item-container"
                style={{
                  padding: "",
                  alignItems: "baseline",
                }}
              >
                {!dontShowProfileUIFor?.includes(AccountType) ? (
                  <div
                    className="position-relative profile_icon mr-15"
                    style={{ width: "3.5rem" }}
                  >
                    <Avatar
                      style={{ width: "3.5rem", height: "3.5rem" }}
                      shape="circle"
                      size="small"
                      className="mr-0"
                      icon={
                        <Image
                          preview={false}
                          className="new-class"
                          src={locationData?.profile_icon_url || defaultImage}
                          fallback={defaultImage}
                        />
                      }
                    />
                    <div
                      className="position-absolute channel_icon"
                      style={{ right: "-1rem", top: "0" }}
                    >
                      <Avatar
                        style={{ width: "1.6rem", maxHeight: "1.6rem" }}
                        shape="circle"
                        size="small"
                        icon={
                          <Image
                            src={
                              SocialMedialogo?.[locationData?.channel]
                                ? SocialMedialogo?.[locationData?.channel]
                                : defaultImage
                            }
                            fallback={defaultImage}
                            preview={false}
                          />
                        }
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {AccountType === "Ads_Campaign" &&
                (IsAdsType
                  ? locationData?.name !== "All ADs"
                  : IsAdsSetType
                  ? locationData?.name !== "All AD Sets"
                  : locationData?.name !== "All AD Campaigns") ? (
                  <div className="multiple-quick-filter-dropdown-img mr-2">
                    {getCampaignStatusIcons(locationData?.status)}
                  </div>
                ) : (
                  ""
                )}
                <strong>
                  {accountType?.includes(AccountType) ? (
                    <Tooltip
                      title={
                        locationData?.name?.length > 15
                          ? locationData?.name
                          : ""
                      }
                      placement="right"
                    >
                      {locationData?.name?.length > 15
                        ? locationData?.name?.substr(0, 15) + "..."
                        : locationData?.name}
                    </Tooltip>
                  ) : (
                    locationData?.name
                  )}
                </strong>
              </div>
            </p>
          )}
        </div>
      </div>
    );
  };
  const renderOurTaggingRow = ({ index, style }) => {
    const tagData = quickFilterResForShareTemplate;
    const rowStyle = {
      ...style,
      borderBottom: "0.1rem solid #c7c7c7",
      paddingTop: "0.2rem",
    };
    return (
      <div key={index} style={rowStyle}>
        <div className="d-flex">
          <p
            style={{
              width: "-webkit-fill-available",
              marginTop: "0.4rem",
            }}
          >
            <strong>{tagData?.name}</strong>
            <div>{tagData?.description}</div>
          </p>
        </div>
      </div>
    );
  };
  // console.log(
  //   "type : ",
  //   type,
  //   "AccountType : ",
  //   AccountType,
  //   "IsAdsSetType : ",
  //   IsAdsSetType,
  //   "IsAdsType : ",
  //   IsAdsType,
  //   "shareTemplateData : ",
  //   shareTemplateData
  // );
  // console.log(
  //   "multileProfileSelectionInShare : ",
  //   multileProfileSelectionInShare
  // );
  if (
    shareTemplateData &&
    quickFilterResForShareTemplate &&
    !multileProfileSelectionInShare?.allow_multiple_selection
  ) {
    return (
      <>
        <div
          className="border-color border border-radius-4 cursor-pointer d-flex align-items-center"
          style={{
            padding: "0.8rem",
            maxWidth:
              AccountType?.toLowerCase() === "locationid" ||
              AccountType?.toLowerCase() === "ticket_tagging"
                ? "40rem"
                : accountType?.includes(AccountType)
                ? "25rem"
                : "19rem",
            width:
              AccountType?.toLowerCase() === "locationid" ||
              AccountType?.toLowerCase() === "ticket_tagging"
                ? "100%"
                : "",
          }}
        >
          <span
            className={`${
              dontShowProfileUIFor?.includes(AccountType) ? "" : "ml-2"
            } text_regular ${
              !accountType?.includes(AccountType) ? "w-100" : "share-name-field"
            }`}
          >
            {quickFilterResForShareTemplate ? (
              <Tooltip
                title={
                  AccountType?.toLowerCase() === "ticket_tagging" ||
                  AccountType?.toLowerCase() === "accountid" ||
                  accountTypeWithLowerCase?.includes(AccountType?.toLowerCase())
                    ? ""
                    : profileId
                }
                placement="bottom"
              >
                <span className="w-100">
                  {/* commenting this bcoz now showing multi selection instead of single */}
                  {/* {AccountType?.toLowerCase() === "accountid" && (
                    <span
                      className="position-relative selectedList mr-2"
                      style={{ width: "2rem" }}
                    >
                      <Avatar
                        style={{
                          width: "2rem",
                          height: "2rem",
                        }}
                        shape="circle"
                        size="small"
                        preview={false}
                        //className="mr-2"
                        icon={
                          <Image
                            src={profileImage ? profileImage : defaultImage}
                            preview={false}
                            fallback={defaultImage}
                          />
                        }
                      />
                      <div
                        className="position-absolute"
                        style={{ right: "-0.7rem", top: "-0.5rem" }}
                      >
                        <Avatar
                          style={{
                            width: "1.2rem",
                            height: "1.2rem",
                          }}
                          shape="circle"
                          size="small"
                          preview={false}
                          icon={
                            <Image
                              src={
                                SocialMedialogo?.[channelImage]
                                  ? SocialMedialogo?.[channelImage]
                                  : defaultImage
                              }
                              preview={false}
                              fallback={defaultImage}
                            />
                          }
                        />
                      </div>
                    </span>
                  )} */}
                  {(AccountType?.toLowerCase() === "locationid" ||
                    AccountType?.toLowerCase() === "accountid" ||
                    accountTypeWithLowerCase?.includes(
                      AccountType?.toLowerCase()
                    )) && (
                    <div className="d-flex position-relative selectedList location__profile mr-2">
                      {AccountType?.toLowerCase() === "locationid" && (
                        <Image
                          style={{
                            width: "1.4rem",
                            height: "1.6rem",
                          }}
                          className="mt-1 "
                          preview={false}
                          src={location}
                          fallback={location}
                        />
                      )}
                      <Tooltip
                        overlayStyle={{
                          width: "auto",
                          maxWidth: "45rem",
                        }}
                        placement="bottom"
                        color="#3B5175"
                        padding="10"
                        title={
                          <FixedSizeList
                            height={
                              dontShowProfileUIFor?.includes(AccountType) &&
                              quickFilterResForShareTemplate?.length === 1
                                ? 35
                                : accountType?.includes(AccountType)
                                ? quickFilterResForShareTemplate?.length > 4
                                  ? 180
                                  : quickFilterResForShareTemplate?.length *
                                    51.5
                                : quickFilterResForShareTemplate?.length === 1
                                ? 98
                                : 230
                            }
                            width={
                              accountType?.includes(AccountType) ? 200 : 410
                            }
                            itemSize={
                              dontShowProfileUIFor?.includes(AccountType)
                                ? 35
                                : accountType?.includes(AccountType)
                                ? 50
                                : 115
                            }
                            style={{
                              overflow:
                                quickFilterResForShareTemplate?.length === 1
                                  ? "hidden"
                                  : "auto",
                            }}
                            itemCount={quickFilterResForShareTemplate?.length}
                            className={
                              quickFilterResForShareTemplate?.length <= 3
                                ? "overflow-hide"
                                : "custom_scroll"
                            }
                          >
                            {renderOurRow}
                          </FixedSizeList>
                        }
                      >
                        <div
                          className="d-flex "
                          style={{ width: "calc(100% - 2.5rem)" }}
                        >
                          {accountType?.includes(AccountType) &&
                          !dontShowProfileUIFor?.includes(AccountType) ? (
                            <div
                              className="position-relative profile_icon account_profile"
                              style={{ width: "3.5rem", marginRight: "0.4rem" }}
                            >
                              <Avatar
                                style={{ width: "2rem", height: "2rem" }}
                                shape="circle"
                                size="small"
                                className={`mr-0 ${
                                  accountType?.includes(AccountType)
                                    ? "profile-small-icon"
                                    : ""
                                }`}
                                icon={
                                  <Image
                                    preview={false}
                                    src={
                                      quickFilterResForShareTemplate?.[0]
                                        ?.profile_icon_url || defaultImage
                                    }
                                    fallback={defaultImage}
                                  />
                                }
                              />
                              <div
                                className="position-absolute channel_icon"
                                style={{ right: "-0.7rem", top: "-0.3rem" }}
                              >
                                <Avatar
                                  style={{
                                    width: "1.6rem",
                                    maxHeight: "1.6rem",
                                  }}
                                  shape="circle"
                                  size="small"
                                  className="small-channel-icon"
                                  icon={
                                    <Image
                                      src={
                                        SocialMedialogo?.[
                                          quickFilterResForShareTemplate?.[0]
                                            ?.channel
                                        ]
                                          ? SocialMedialogo?.[
                                              quickFilterResForShareTemplate?.[0]
                                                ?.channel
                                            ]
                                          : defaultImage
                                      }
                                      fallback={defaultImage}
                                      preview={false}
                                    />
                                  }
                                />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {AccountType === "Ads_Campaign" &&
                          (IsAdsType
                            ? quickFilterResForShareTemplate?.[0]?.name !==
                              "All ADs"
                            : IsAdsSetType
                            ? quickFilterResForShareTemplate?.[0]?.name !==
                              "All AD Sets"
                            : quickFilterResForShareTemplate?.[0]?.name !==
                              "All AD Campaigns") ? (
                            <div className="multiple-quick-filter-dropdown-img">
                              {getCampaignStatusIcons(
                                quickFilterResForShareTemplate?.[0]?.status
                              )}
                            </div>
                          ) : (
                            ""
                          )}
                          <span
                            className="shared_dashboard_stored_name mr-1"
                            style={{
                              marginLeft: accountType?.includes(AccountType)
                                ? "0.5rem"
                                : "",
                              width: dontShowProfileUIFor?.includes(AccountType)
                                ? ""
                                : quickFilterResForShareTemplate?.length ===
                                    1 &&
                                  quickFilterResForShareTemplate?.[0]
                                    ?.StoreCode === "" &&
                                  quickFilterResForShareTemplate?.[0]
                                    ?.StoreCode === "NA"
                                ? "95%"
                                : quickFilterResForShareTemplate?.[0]
                                    ?.StoreCode &&
                                  quickFilterResForShareTemplate?.[0]
                                    ?.StoreCode !== "" &&
                                  quickFilterResForShareTemplate?.[0]
                                    ?.StoreCode !== "NA"
                                ? "100%"
                                : "100%",
                            }}
                          >
                            {`${
                              quickFilterResForShareTemplate?.[0]?.name
                                ?.length > 15
                                ? quickFilterResForShareTemplate?.[0]?.name?.substr(
                                    0,
                                    15
                                  ) + "..."
                                : quickFilterResForShareTemplate?.[0]?.name
                            }`}
                            {/* selectedOptions[0]?.name?.length) > 15
                  ? selectedOptions[0]?.name?.substr(0, 15) + "..."
                  : selectedOptions[0]?.name */}
                            {/* {quickFilterResForShareTemplate?.[0]?.StoreCode
                            ? `(${quickFilterResForShareTemplate?.[0]?.StoreCode})`
                            : ""} */}
                          </span>
                          <span>
                            {quickFilterResForShareTemplate?.length > 1
                              ? ` +${
                                  quickFilterResForShareTemplate?.length - 1
                                }`
                              : ""}
                          </span>
                        </div>
                      </Tooltip>
                    </div>
                  )}
                  {AccountType?.toLowerCase() === "ticket_tagging" && (
                    <div className="d-flex position-relative selectedList location__profile mr-2">
                      <Tooltip
                        overlayStyle={{
                          width: "auto",
                          maxWidth: "45rem",
                        }}
                        placement="bottom"
                        color="#3B5175"
                        padding="10"
                        title={
                          //   <FixedSizeList
                          //   height={98}
                          //   width={410}
                          //   itemSize={115}
                          //   style={{
                          //     overflow: "hidden",
                          //   }}
                          //   itemCount={1}
                          //   className="custom_scroll"
                          // >
                          //   {renderOurTaggingRow}
                          // </FixedSizeList>
                          <div>
                            {quickFilterResForShareTemplate?.name ? (
                              <div
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: "0.2rem",
                                }}
                              >
                                {quickFilterResForShareTemplate?.name}
                              </div>
                            ) : (
                              ""
                            )}
                            {quickFilterResForShareTemplate?.description ? (
                              <div>
                                {quickFilterResForShareTemplate?.description}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        }
                      >
                        <div
                          className="d-flex "
                          style={{ width: "calc(100% - 2.5rem)" }}
                        >
                          <span
                            className="shared_dashboard_stored_name mr-1"
                            style={{
                              width: "100%",
                            }}
                          >
                            {`${quickFilterResForShareTemplate?.name}`}
                          </span>
                        </div>
                      </Tooltip>
                    </div>
                  )}
                  {AccountType?.toLowerCase()?.trim() !== "locationid" &&
                  AccountType?.toLowerCase()?.trim() !== "accountid" &&
                  !accountTypeWithLowerCase?.includes(
                    AccountType?.toLowerCase()
                  ) &&
                  AccountType?.toLowerCase()?.trim() !== "ticket_tagging" ? (
                    <>
                      {profileId?.length > 17
                        ? profileId?.substr(0, 17) + " ..."
                        : profileId}
                    </>
                  ) : (
                    ""
                  )}
                </span>
              </Tooltip>
            ) : (
              "No Data"
            )}
          </span>
        </div>
      </>
    );
  } else
    return (
      <>
        {(AccountType === "LocationID" || accountType?.includes(AccountType)) &&
        (type !== "share-modal" ||
          (type === "share-modal" && isSwitchingAllowed)) ? (
          <MultipleQuickFiltersSelectDropdown
            type={type}
            AccountType={AccountType}
            supportedAccountTypeList={accountType}
            IsAdsSetType={IsAdsSetType}
            IsAdsType={IsAdsType}
            isSwitchingAllowed={isSwitchingAllowed}
          />
        ) : (
          <Select
            disabled={
              personalisationSettingsInPersonalisationState?.isPersonalizationPreviewOpen
            }
            mode={
              AccountType === "LocationID" || accountType?.includes(AccountType)
                ? "multiple"
                : ""
            }
            // dropdownStyle = {{ position: "fixed" }}
            open={open}
            onDropdownVisibleChange={(visible) => setOpen(visible)}
            popupClassName={`${
              authParams?.theme_type === "1"
                ? "darkTheme ProfileSelectionDropDown"
                : "lightTheme ProfileSelectionDropDown"
            } ${
              AccountType === "LocationID" ||
              accountType?.includes(AccountType) ||
              AccountType === "Ticket_Tagging"
                ? "Location_dropdown"
                : ""
            }`}
            bordered={false}
            showSearch={profileDrop === "mouseenter" ? true : false}
            style={
              type === "share-modal"
                ? {
                    width: "100%",
                    maxHeight: "30rem",
                    overflow: "auto",
                  }
                : {
                    width:
                      (AccountType === "LocationID" ||
                        AccountType === "Ticket_Tagging") &&
                      type !== "share-modal"
                        ? "40rem"
                        : type === "global_dashboard"
                        ? "20rem"
                        : "100%",
                  }
            }
            className={`border-radius-4 ProfileSelection--selected--item ${
              type === "share-modal"
                ? "share-modal-locations-padding custom_scroll1"
                : ""
            }`}
            defaultValue={
              updatedProfileList && updatedProfileList?.length > 0
                ? updatedProfileList?.[0]
                  ? getDefaultProfileValue(updatedProfileList?.[0])
                  : "Profile"
                : "No Profile"
            }
            placeholder={`Select ${
              AccountType === "AccountID"
                ? "Profiles"
                : AccountType === "ObjectID"
                ? "Form"
                : AccountType === "Category"
                ? "Category"
                : AccountType === "CampaignID"
                ? "Campaign"
                : AccountType === "LocationID"
                ? "Locations"
                : AccountType?.toLowerCase() === "fbgroupid"
                ? "Facebook Group"
                : AccountType === "Ticket_Tagging"
                ? "Labels"
                : AccountType === "Ads_Campaign"
                ? "AD Campaign"
                : AccountType === "ProfileID"
                ? "Location Profiles"
                : ""
            }`}
            onMouseEnter={(e) => handleOnSelectClick(e)}
            onMouseLeave={(e) => handleOnSelectClick(e)}
            onChange={(e) => handleOnSelectChange(e, "Profile")}
            title={null}
            value={
              profileLoader &&
              (type === "schedule_report" || type === "CommandCenterCampaign")
                ? null
                : multileProfileSelectionInShare?.searchQuickFilterLoader &&
                  type === "share-dashboard"
                ? null
                : selectedProfileValue
            }
            // value={
            //   <>
            //     {panes[index]?.profiles?.length > 0 ||
            //     quickFilterResForShareTemplate ? (
            //       <Tooltip title={profileId} placement="bottom">
            //         {AccountType === "AccountID" && (
            //           <div
            //             className="position-relative selectedList mr-2"
            //             style={{ width: "2rem" }}
            //           >
            //             <Avatar
            //               style={{
            //                 width: "2rem",
            //                 height: "2rem",
            //               }}
            //               shape="circle"
            //               size="small"
            //               preview={false}
            //               //className="mr-2"
            //               icon={
            //                 <Image
            //                   src={profileImage ? profileImage : defaultImage}
            //                   preview={false}
            //                   fallback={defaultImage}
            //                 />
            //               }
            //             />
            //             <div
            //               className="position-absolute"
            //               style={{ right: "-0.7rem", top: "-0.5rem" }}
            //             >
            //               <Avatar
            //                 style={{
            //                   width: "1.2rem",
            //                   height: "1.2rem",
            //                 }}
            //                 shape="circle"
            //                 size="small"
            //                 preview={false}
            //                 icon={
            //                   <Image
            //                     src={
            //                       SocialMedialogo?.[channelImage]
            //                         ? SocialMedialogo?.[channelImage]
            //                         : defaultImage
            //                     }
            //                     preview={false}
            //                     fallback={defaultImage}
            //                   />
            //                 }
            //               />
            //             </div>
            //           </div>
            //         )}
            //         {AccountType === "LocationID" && (
            //           <div
            //             className="position-relative selectedList location__profile mr-2"
            //             style={{ width: "2rem" }}
            //           >
            //             <Image
            //               style={{
            //                 width: "1.4rem",
            //                 height: "1.6rem",
            //               }}
            //               className="mt-1 "
            //               preview={false}
            //               src={location}
            //               fallback={location}
            //             />
            //           </div>
            //         )}
            //         {AccountType !== "LocationID" && profileId?.length > 17
            //           ? profileId?.substr(0, 17) + " ..."
            //           : profileId}
            //       </Tooltip>
            //     ) : (
            //       "No Data"
            //     )}
            //   </>
            // }
            suffixIcon={
              type !== "share-modal" && (
                <img
                  src={
                    authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                  }
                  alt="arrow"
                  className="accordionArrow"
                  style={{
                    transform: `rotate("180deg")`,
                  }}
                />
              )
            }
          >
            {(type === "schedule_report"
              ? !profileLoader
              : type === "share-dashboard"
              ? !multileProfileSelectionInShare?.searchQuickFilterLoader
              : true) &&
              updatedProfileList &&
              updatedProfileList?.map((el, i) => {
                return (
                  <Option
                    key={el?.id}
                    value={`${el?.name}valuesplit${el?.id}valuesplit${el?.channel}valuesplit${el?.profile_icon_url}valuesplit${el?.start_date}valuesplit${el?.end_date}valuesplit${el?.StoreCode}valuesplit${el?.StoreAddress}`}
                    label={el?.name}
                    disabled={
                      (
                        AccountType === "LocationID" ||
                        accountType?.includes(AccountType)
                          ? isAllSelectedLocation(el?.name)
                          : false
                      )
                        ? isAllSelectedLocation(el?.name)
                        : false
                    }
                    //title={el?.name}
                    className={`${
                      (AccountType === "LocationID" ||
                        accountType?.includes(AccountType) ||
                        AccountType === "Ticket_Tagging") &&
                      "p-0"
                    }`}
                  >
                    <Tooltip
                      title={el?.name}
                      placement="right"
                      className="ProfileSelection--item-container"
                    >
                      {AccountType === "AccountID" && (
                        <div
                          className="position-relative profile_icon mr-15"
                          style={{ width: "3.5rem" }}
                        >
                          <Avatar
                            style={{ width: "3.5rem", height: "3.5rem" }}
                            shape="circle"
                            size="small"
                            className="mr-0"
                            icon={
                              <Image
                                preview={false}
                                src={el?.profile_icon_url}
                                fallback={defaultImage}
                              />
                            }
                          />
                          <div
                            className="position-absolute channel_icon"
                            style={{ right: "-1rem", top: "0" }}
                          >
                            <Avatar
                              style={{ width: "1.6rem", maxHeight: "1.6rem" }}
                              shape="circle"
                              size="small"
                              icon={
                                <Image
                                  src={
                                    SocialMedialogo?.[el?.channel]
                                      ? SocialMedialogo?.[el?.channel]
                                      : defaultImage
                                  }
                                  fallback={defaultImage}
                                  preview={false}
                                />
                              }
                            />
                          </div>
                        </div>
                      )}
                      {AccountType === "LocationID" && (
                        <>
                          <div
                            className="d-flex border-bottom mt-1 Location__profile "
                            style={{ padding: "0.5rem 1.2rem" }}
                          >
                            <div className="mr-10 Location__profile--locationicon">
                              <Image
                                style={{
                                  width: "1.4rem",
                                  height: "1.6rem",
                                }}
                                className="mt-1"
                                preview={false}
                                src={location}
                                fallback={location}
                              />
                            </div>

                            <div className="d-flex flex-column Location__profile--location">
                              <span className="text_heading text-wrap font-weight600 Location__profile--locationname">
                                {el?.name}
                              </span>
                              <span className="text-gray text-wrap break-all Location__profile--locationaddress">
                                {el?.StoreAddress}
                              </span>
                              <div className="d-flex justify-content-between Location__profile--locationratingcode">
                                <span className="mr-15 d-flex align-items-center ">
                                  <Tooltip
                                    placement="left"
                                    title={el?.averageRating}
                                  >
                                    <Rate
                                      disabled
                                      value={el?.averageRating}
                                      className="ratingList mr-1 mb-1"
                                    />
                                  </Tooltip>

                                  <span className="font-weight600">
                                    {el?.totalReviewCount}
                                  </span>
                                  <span className="font-weight600">
                                    {"(" + el?.averageRating + ")"}
                                  </span>
                                </span>
                                <span className="mr-15 d-flex align-items-center">
                                  <span>
                                    <span className="font-weight600">
                                      Store Code:
                                    </span>{" "}
                                    <span className="text-gray">
                                      {el?.StoreCode?.length > 1
                                        ? el?.StoreCode
                                        : "NA"}
                                    </span>
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {AccountType === "Ticket_Tagging" ? (
                        <>
                          <div
                            className="d-flex border-bottom mt-1 Location__profile "
                            style={{ padding: "0.5rem 1.2rem" }}
                          >
                            <div className="d-flex flex-column Location__profile--location">
                              <span className="text_heading text-wrap font-weight600 Location__profile--locationname">
                                {el?.name?.length > 50 &&
                                type !== "schedule_report"
                                  ? el?.name?.substr(0, 50) + " ..."
                                  : el?.name}
                              </span>
                              <span className="text-gray text-wrap break-all Location__profile--locationaddress">
                                {el?.description ? el?.description : ""}
                              </span>
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {AccountType !== "LocationID" &&
                      AccountType !== "Ticket_Tagging" ? (
                        <Text className="text_heading ml-2">
                          {el?.name?.length > 15 && type !== "schedule_report"
                            ? el?.name?.substr(0, 15) + " ..."
                            : el?.name}
                          {/* {el?.name} */}
                        </Text>
                      ) : (
                        ""
                      )}
                    </Tooltip>
                  </Option>
                );
              })}
          </Select>
        )}
      </>
    );
};

export default React.memo(ProfileSelection, isEqual);
